<template>
  <main class="app-main">

    <!-- Header -->
    <div class="app-content-header">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-6">
            <h3 class="mb-0">إضافة عميل</h3>
          </div>

          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item">
                <router-link to="/">الرئيسية</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link to="/clients">العملاء</router-link>
              </li>
              <li class="breadcrumb-item active">
                إضافة عميل
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <!-- Content -->
    <div class="app-content">
      <div class="container-fluid">

        <div class="row justify-content-center">
          <div class="col-12 col-sm-10">

            <div class="card card-secondary card-outline mb-4 mt-4">
              <div class="card-header">
                <div class="card-title">إضافة عميل</div>
              </div>

              <errorAlert v-if="hasError" :alertMessage="message" />

              <form @submit.prevent="submitData">

                <div class="card-body">
                  <div class="row">

                    <div class="col-12 col-sm-6 mb-3">
                      <label class="form-label">الاسم:</label>
                      <input type="text" v-model="name" class="form-control">
                    </div>

                    <div class="col-12 col-sm-6 mb-3">
                      <label class="form-label">الجوال:</label>
                      <input type="text" v-model="mobile" class="form-control">
                    </div>

                    <div class="col-12 col-sm-6 mb-3">
                      <label class="form-label">كلمة المرور:</label>
                      <input type="password" v-model="password" class="form-control">
                    </div>

                  </div>
                </div>

                <div class="card-footer text-end">
                  <button v-if="!formLoader" type="submit" class="btn btn-success">
                    حفظ
                  </button>
                  <loader v-if="formLoader" />
                </div>

              </form>

            </div>

          </div>
        </div>

      </div>
    </div>

  </main>
</template>

<script>
import { toast } from '@/helpers/tools';

export default {
  name: 'ClientsCreate',

  data(){
    return {
      formLoader: false,
      hasError: false,
      message: '',
      name: '',
      mobile: '',
      password: '',
    }
  },

  methods:{
    submitData(){
      this.formLoader = true;
      this.hasError = false;

      if(!this.name || !this.mobile || !this.password){
        this.message = 'كل البيانات مطلوبة';
        this.hasError = true;
        this.formLoader = false;
        return;
      }

      this.$http.post('/api/admin/users/create', {
        name: this.name,
        mobile: this.mobile,
        password: this.password,
      }).then(() => {
        toast('تم إضافة العميل بنجاح', 'success');
        this.$router.replace('/clients').catch(() => {});
      }).catch(err => {
        [this.message] = this.$globalError(err, true);
        this.hasError = true;
      }).finally(() => {
        this.formLoader = false;
      });
    }
  }
}
</script>